import * as types from '../actions/types'
import Immutable from 'immutable'

import { isPrimitive } from '../utils/helpers'

const INITIAL_STATE = Immutable.fromJS({
    documentos: [],
    busqueda: '',
    tipo: 0
})

export default function (state = INITIAL_STATE, action) {
	switch (action.type) {
		case types.BUSQUEDADOCUMENTO_OBTENER_DOCUMENTOS:
			state = state.set('documentos', Immutable.fromJS(action.payload.data))
			return state
		case types.BUSQUEDADOCUMENTO_REINICIAR_ESTADO:
            state = INITIAL_STATE
            return state
        case types.BUSQUEDADOCUMENTO_MODIFICAR_INPUTS:
			if (isPrimitive(action.payload.value)) {
				state = state.setIn(`${action.payload.path}`.split('.'), action.payload.value)
			} else {
				if (action.payload.immutable === false) {
					state = state.setIn(`${action.payload.path}`.split('.'), action.payload.value)
				} else {
					state = state.setIn(`${action.payload.path}`.split('.'), Immutable.fromJS(action.payload.value))
				}
			}
			return state
        default:
			return state
	}
}



// WEBPACK FOOTER //
// ./src/reducers/busquedadocumento.js